// Module
var code = "<div id=\"passwordReset\"> <start-logo></start-logo> <h3 class=\"label-text\" ng-if=\"!vm.failure\"> {{'VERIFY_RESET_PASSWORD_TOKEN.VERIFYING'|t}} </h3> <h3 class=\"label-text\" ng-if=\"vm.failure\" ng-bind-html=\"'VERIFY_RESET_PASSWORD_TOKEN.ERROR'|t\"> </h3> </div> ";
// Exports
module.exports = code;